// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import globalHeader from '@common/components/header'
import globalFooter from '@common/components/footer'
import commonFig from '@common/main.js'
const merge = require('webpack-merge')
// 公用样式
require('@/assets/css/common.less')

// 合并公用配置和自定义配置
let config = merge(commonFig, {
  watch: {
    '$route': 'getProfile',
    profile (val) {
      if (val && val.id && window.yunliao) {
        console.log('init')
        window.AnalysysAgent.alias(val.id)
        window.yunliao.init()
      }
    }
  },
  created () {
    window.AnalysysAgent.pageView('估价器')
  },
  components: {globalHeader, globalFooter}
})
/* eslint-disable no-new */
new Vue(config)
